import { render, staticRenderFns } from "./BaseImageInput.vue?vue&type=template&id=485fe94d"
import script from "./BaseImageInput.vue?vue&type=script&lang=js"
export * from "./BaseImageInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports